module.exports = __webpack_public_path__ + "img/public/SiteIcons/threadsIconBlack.svg?dfb35dc2";